import AnalyticsActionCreator from '../../../actions/AnalyticsActionCreator';

const ProjectionsBL = {
  analyticAction(apath, actionToBe, descriptionOFEvent, eventTriggered) {
    AnalyticsActionCreator.track(
      {
        path: apath,
        action: actionToBe,
      },
      {
        description: descriptionOFEvent,
        event: eventTriggered,
      }
    );
  },
  nextEarningProjectionPeriod(projectionSummary) {
    if (projectionSummary !== undefined) {
      let i;
      for (i = 1; i <= projectionSummary.projection_periods.length; i++) {
        if (projectionSummary.projection_periods[i] !== undefined) {
          if (projectionSummary.projection_periods[i].earnings !== undefined) {
            if (projectionSummary.projection_periods[i].earnings.length > 0) {
              return true;
            } else {
              return false;
            }
          }
        }
      }
      return false;
    }
  },
  dateConversion(value) {
    if (value !== '') {
      const monthName = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      const fullDate = new Date(value);
      const day = fullDate.getDate();
      const month = fullDate.getMonth();
      const year = fullDate.getFullYear();
      return `${`0${day}`.slice(-2)} ${monthName[month].substr(0, 3)} ${year
        .toString()
        .substr(2, 4)}`;
    }
  },
  getTileMessages(status, data, errorObj, content) {
    let messageObj = {};
    let nextTitle = '';
    switch (status) {
      case 200:
        if (data.projection_periods[0].warning_days.length > 0) {
          messageObj = {
            title: content.projection200BadTitle,
            subTitle: content.projection200BadSubtitle,
          };
        } else {
          messageObj = {
            title: content.projection200GoodTitle,
            subTitle: content.projection200GoodSubTitle,
          };
        }
        break;
      case 404:
        messageObj = {
          title: content.projection404Title,
          subTitle: content.projection404Subtitle,
        };
        break;
      case 409:
        switch (errorObj.code) {
          case '0000':
            messageObj = {
              title: content.projection409_0Title,
              subTitle: content.projection409_0Subtitle,
            };
            break;
          case '0001':
            if (errorObj.metadata) {
              const availableDays = errorObj.metadata.available_days;
              const requiredDays = errorObj.metadata.required_days;
              let daysRemaining = requiredDays - availableDays;
              nextTitle = `${daysRemaining} days left...`;
            } else {
              nextTitle = content.projection409_1Subtitle;
            }
            messageObj = {
              title: content.projection409_1Title,
              subTitle: nextTitle,
            };
            break;
          case '0002':
            messageObj = {
              title: content.projection409_2Title,
              subTitle: content.projection409_2Subtitle,
            };
            break;
        }
        break;
      case 500:
        messageObj = {
          title: content.projection500Title,
          subTitle: content.projection500Subtitle,
        };
        break;
    }
    return messageObj;
  },
};
export default ProjectionsBL;
